var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticStyle:{"z-index":"6"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }